module.exports = __webpack_public_path__ + "static/paypal_monei-5b7b88dcba129a8ac32395c20419bc6f.svg";